<template>
  <div v-if="!ready" v-loading="!ready" element-loading-text="拼命加载中" class="page-loading"></div>
  <div v-else>
    <div class="flex">
      <div class="left">
        <slot name="title"><h3 class="m-v-0" v-if="!departments.length">部门文件共享</h3></slot>
        <el-tabs v-model="active_tag" v-if="departments.length" class="file-tabs">
          <el-tab-pane label="共享文件" name="public"></el-tab-pane>
          <el-tab-pane v-for="department in departments" :key="department.uid" :name="department.uid"
                       :label="`${department.name}(存档)`"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="right">
        <el-input placeholder="搜索文件" class="max-width-200 w-a"
                  suffix-icon="el-icon-search" v-model="search"></el-input>
        <router-link class="el-button el-button--small el-button--success" v-if="is_admin"
                     :to="$location.admin_file_edit(active_tag === 'public' ? null : {department_uid: active_tag})">
          <icon name="plus"></icon>
          添加文件
        </router-link>
      </div>
    </div>
    <el-table :data="page" border :key="active_tag">
      <el-table-column prop="desc" label="说明">
        <template slot-scope="scope">
          <div class="text-pre-wrap"
               v-html="$highlight(scope.row.desc, scope.row.$$pinyin.desc)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="文件">
        <template slot-scope="scope">
          <icon :name="scope.row.name | fileicon"></icon>
          <span v-html="$highlight(scope.row.name, scope.row.$$pinyin.name)"></span>
        </template>
      </el-table-column>
      <el-table-column v-if="active_tag !== 'public'" prop="public" label="全校共享">
        <template slot-scope="scope">{{scope.row.public ? '是' : '否'}}</template>
      </el-table-column>
      <el-table-column prop="time_modify" label="更新时间">
        <template slot-scope="scope">{{scope.row.time_modify | sub(0, -3)}}</template>
      </el-table-column>
      <el-table-column prop="size" label="大小">
        <template slot-scope="scope">{{scope.row.size | filesize}}</template>
      </el-table-column>
      <el-table-column v-if="active_tag === 'public'" prop="department_name" label="部门">
        <template slot-scope="scope">
          <span v-html="$highlight(scope.row.department_name, scope.row.$$pinyin.department_name)"></span>
        </template>
      </el-table-column>
      <el-table-column v-if="active_tag !== 'public'" prop="user_name" label="上传人">
        <template slot-scope="scope">
          <span v-html="$highlight(scope.row.user_name, scope.row.$$pinyin.user_name)"></span>
        </template>
      </el-table-column>
      <el-table-column label="操作" class-name="no-padding" align="center">
        <template slot-scope="scope">
          <a :href="scope.row.url" class="el-button el-button--mini el-button--success"
             :download="scope.row.name" target="_blank">
            下载
          </a>
          <el-button size="mini" type="success" @click="detail_dialog = true; detail = scope.row;">
            查看
          </el-button>
          <template v-if="is_admin && $user.uid === scope.row.user_uid">
            <router-link class="el-button el-button--mini el-button--warning"
                         :to="$location.admin_file_edit({file_uid: scope.row.uid})">
              编辑
            </router-link>
            <el-button size="mini" type="danger" @click="deleteFile(scope.row)"
                       :loading="scope.row.$$loading">
              删除
            </el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination v-if="filtered.length > pageInfo.page" :total="filtered.length"
                   :page-size="pageInfo.page" :current-page.sync="pageInfo.current"
                   class="text-center m-t-10" layout="prev, pager, next">
    </el-pagination>
    <el-dialog :visible.sync="detail_dialog" width="33%" title="查看文件">
      <template v-if="detail">
        <el-form label-position="top">
          <el-form-item label="部门">{{detail.department_name}}</el-form-item>
          <el-form-item label="更新时间">{{detail.time_modify | sub(0, -3)}}</el-form-item>
          <el-form-item label="文件" class="text-ellipsis">
            <div class="text-ellipsis">
              <icon :name="detail.name | fileicon"></icon>
              {{detail.name}}
            </div>
          </el-form-item>
          <el-form-item label="说明" class="m-b-0">
            <div class="text-pre-wrap l-h-n m-t-8">{{detail.desc}}</div>
          </el-form-item>
        </el-form>
        <div slot="footer" class="text-center">
          <a :href="detail.url" :download="detail.name" target="_blank" class="el-button el-button--success">
            <icon name="download"></icon>
            下载文件
          </a>
          <el-button type="default" @click="detail_dialog = false">返回</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import keyBy from 'lodash/keyBy'
import orderBy from 'lodash/orderBy'

import * as Storage from 'api/storage'
import page from 'utils/page'

export default {
  props: {
    admin: Boolean,
  },
  data () {
    return {
      detail_dialog: false,
      detail: null,
      public_list: null,
      departments: null,
      department_map: null,
      ready: false,
      active_tag: 'public',
      pageInfo: {
        page: 20,
        current: 1,
      },
      search: '',
    }
  },
  computed: {
    is_admin () {
      return this.admin || this.$route.name === this.$location.admin_file_center().name
    },
    list () {
      if (this.active_tag === 'public') return this.public_list
      let department = this.department_map[this.active_tag]
      return department && department.list || []
    },
    filtered () {
      let searchFields = ['name', 'desc']
      searchFields.push(this.active_tag === 'public' ? 'department_name' : 'user_name')
      return this.$search(this.list, this.search, searchFields)
    },
    page () {
      return page(this.filtered, this.pageInfo)
    },
  },
  methods: {
    init () {
      this.ready = false
      this.$guard()(async () => {
        let [public_list, departments] = await Promise.all([
          Storage.public_list(),
          this.loadDepartments(),
        ])
        let department_map = keyBy(departments, 'uid')
        departments.forEach(department => {
          department.list = orderBy(department.list, 'time_modify', 'desc')
        })
        this.public_list = orderBy(public_list, 'time_modify', 'desc')
        this.departments = departments
        this.department_map = department_map
        this.active_tag = this.$query.active_tag
        if (!department_map[this.active_tag]) {
          this.active_tag = 'public'
          this.$updateQuery({active_tag: this.active_tag})
        }
        this.ready = true
      })
    },
    async loadDepartments () {
      let departments = await Storage.user_department_list({user_uid: this.$user.uid})
      let concurrent_count = 10, current = 0
      while (current < departments.length) {
        let list = departments.slice(current, current + concurrent_count)
        await Promise.all(list.map(async department => {
          department.list = await Storage.list({department_uid: department.uid})
          department.list.forEach(file => file.department_name = department.name)
        }))
        current += concurrent_count
      }
      return departments
    },
    async deleteFile (file) {
      if (file.$$loading) return
      if (!await this.$confirm('确定要删除吗？')) return
      this.$guard(file, '$$loading')(async () => {
        await Storage.remove({uid: file.uid})
        this.$message.success('删除成功')
        let idx = this.list.findIndex(f => f.uid === file.uid)
        this.list.splice(idx, 1)
      })
    },
  },
  created () {
    this.init()
  },
  watch: {
    $route () {
      if (!this.$dontReload) this.init()
    },
    active_tag () {
      this.$updateQuery({active_tag: this.active_tag})
    },
  },
}
</script>

<style scoped lang="scss">
.flex {
  display: flex;
  align-items: flex-end;
  margin-bottom: 15px;
  .left {
    flex: 1;
    padding-right: 10px;
  }
}
</style>
<style lang="scss">
.file-tabs {
  .el-tabs__header {
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/file/FileCenter.vue